import { Shareholder } from 'typescript-fetch-api'

import { RootStoreState } from '../root'

/**
 * @param state Select the currently selected shareholder account from the root store state.
 */
export const accountSelector = (state: RootStoreState): Shareholder | undefined => state.accounts.accounts.find(account => account.id === state.accounts.selectedAccountId)
